import {
  AuxiliaryDataCacheContextAction,
  AuxiliaryDataCacheContextState,
  AuxiliaryDataCacheContextActionType,
} from './types';

// It's always a good thing to put the typing for the result of our reducer
// Some weird Typescript errors can happen if we don't define it
const reducer = (
  prevState: AuxiliaryDataCacheContextState,
  action: AuxiliaryDataCacheContextAction
): AuxiliaryDataCacheContextState => {
  switch (action.type) {
    case AuxiliaryDataCacheContextActionType.SET_APPLICATIONS:
      return {
        ...prevState,
        applications: action.applications,
      };
    case AuxiliaryDataCacheContextActionType.SET_REMINDERS:
      return {
        ...prevState,
        reminders: action.reminders,
      };
    case AuxiliaryDataCacheContextActionType.SET_USERS:
      return {
        ...prevState,
        users: action.users,
      };
    case AuxiliaryDataCacheContextActionType.CLEAR_ALL:
      return {
        ...prevState,
        applications: {},
        reminders: {},
        users: {},
      };
  }
};

export default reducer;
